"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchBroadbandAddresses = fetchBroadbandAddresses;
exports.fetchHandsets = fetchHandsets;
exports.fetchLowestPlanPrice = fetchLowestPlanPrice;
exports.fetchUpSellProducts = fetchUpSellProducts;
exports.watchProductCatalog = watchProductCatalog;
exports.watchProductRelationshipOfferings = watchProductRelationshipOfferings;
var _effects = require("redux-saga/effects");
var _services = require("../../services");
var _upsellParser = _interopRequireDefault(require("../upsell/upsellParser"));
var _AccessoryParser = require("../../store/upsell/AccessoryParser");
var _productCatalogSelectors = require("./productCatalogSelectors");
var _widgetSelectors = require("../widget/widgetSelectors");
var _constants = require("../../utils/constants");
var _productCatalogActions = require("./productCatalogActions");
var _productCatalogUtil = require("../../utils/productCatalogUtil");
var _upsellActions = require("../upsell/upsellActions");
var _CookiesManager = _interopRequireDefault(require("../../utils/CookiesManager"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function* fetchHandsets(action) {
  try {
    const url = `${_constants.API_PATH.PRODUCT_CATALOG}/v4/productOffering?expand=productSpecification,productOfferingPrice&fields=productSpecification.productSpecCharacteristic.brand.productSpecCharacteristicValue.value,productSpecification.productSpecCharacteristic.model.productSpecCharacteristicValue.value,productSpecification.productSpecCharacteristic.brand.name,productSpecification.productSpecCharacteristic.model.name&category.id.eq=handset&productOfferingPrice.priceType.eq=recurring,recurring-promo,upfront&lifecycleStatus.eq=Launched&prodSpecCharValueUse.stockAvailability.productSpecCharacteristicValue.value.eq=true`;
    const response = yield (0, _effects.call)(_services.http.get, url);
    const handsets = (0, _productCatalogUtil.filterProductCatalogEmptyBrands)(response);
    yield (0, _effects.put)({
      ...(0, _productCatalogActions.setHandsets)(handsets),
      instanceId: action.instanceId
    });
  } catch (e) {
    console.log(e);
  }
}
function* fetchBroadbandAddresses(action) {
  try {
    var _cookies$address;
    const {
      cookies
    } = yield (0, _effects.select)((0, _widgetSelectors.selectConfig)(action.instanceId));
    const {
      domain,
      path
    } = (_cookies$address = cookies.address) !== null && _cookies$address !== void 0 ? _cookies$address : {};
    _CookiesManager.default.deleteCookie('address', domain, path);
    const url = `${_constants.API_PATH.ADDRESS_FINDER}/geographicAddress?addressKeyword=${action.payload.address}`;
    const response = yield (0, _effects.call)(_services.http.get, url);
    yield (0, _effects.put)({
      type: _productCatalogActions.FETCH_BROADBAND_ADDRESSES_SUCCESS,
      payload: {
        addresses: response,
        cookies: action.payload.cookies
      },
      instanceId: action.instanceId
    });
  } catch (error) {
    if ((error === null || error === void 0 ? void 0 : error.message) !== _constants.DUPLICATE_REQUEST_CANCELLATION) yield (0, _effects.put)({
      type: _productCatalogActions.FETCH_BROADBAND_ADDRESSES_ERROR,
      payload: {
        addressError: error.message
      },
      instanceId: action.instanceId
    });
  }
}
function* fetchLowestPlanPrice(action) {
  try {
    var _response$price;
    const [response] = yield (0, _effects.call)(_services.http.get, `/productCatalog/v4/productOfferingPrice/?sort=price.value&priceType.eq=commerceAdditionalPlanPrice&limit=1`);
    const foundPrice = response === null || response === void 0 ? void 0 : (_response$price = response.price) === null || _response$price === void 0 ? void 0 : _response$price.value;
    if (foundPrice) {
      yield (0, _effects.put)({
        type: _productCatalogActions.SET_PLAN_LOWEST_PRICE,
        payload: {
          price: foundPrice
        },
        instanceId: action.instanceId
      });
    }
  } catch (error) {
    console.error('Cannot get lowest price from product catalog', error);
  }
}
function* watchProductCatalog() {
  yield (0, _effects.takeEvery)(_productCatalogActions.FETCH_HANDSETS, fetchHandsets);
  yield (0, _effects.takeEvery)(_productCatalogActions.FETCH_LOWEST_PLAN_PRICE, fetchLowestPlanPrice);
}
function* fetchUpSellProducts(action) {
  const relationshipOfferings = (yield (0, _effects.select)((0, _productCatalogSelectors.selectRelationshipOfferings)(action.instanceId))) || [];
  const relationshipOfferingsIds = relationshipOfferings.map(offering => offering.id);
  const isInStore = offering => relationshipOfferingsIds.includes(offering);
  const {
    connectivityPlan: configuredConnectivityPlan
  } = yield (0, _effects.select)((0, _widgetSelectors.selectProductCatalog)(action.instanceId));
  const connectivityPlanId = configuredConnectivityPlan.id;
  if (!action.payload.relationshipIds.every(isInStore) || relationshipOfferings.length === 0) {
    yield (0, _effects.put)({
      ...(0, _productCatalogActions.setProductRelationshipOffering)([]),
      instanceId: action.instanceId
    });
    try {
      const url = `${_constants.API_PATH.PRODUCT_CATALOG}/v4/productOffering?id.eq=${action.payload.relationshipIds},${connectivityPlanId}&expand=productOfferingPrice,productSpecification&fields=productSpecification,productOfferingPrice,name,category,attachment,description`;
      const response = yield (0, _effects.call)(_services.http.get, url);
      const connectivityPlan = response.find(offering => offering.id === connectivityPlanId);
      const upsellOfferings = response.filter(offering => offering.id !== connectivityPlanId);
      yield (0, _effects.put)({
        ...(0, _upsellActions.setConnectivityPlan)(connectivityPlan),
        instanceId: action.instanceId
      });
      for (const product of upsellOfferings) {
        if (product.category[0].name === _constants.PRODUCT_TYPES.ACCESSORY.toLocaleLowerCase()) {
          const variants = yield (0, _effects.call)(_services.http.get, `${_constants.API_PATH.PRODUCT_CATALOG}/v4/productOffering?productSpecification.id.eq=${product.productSpecification.id}&expand=productSpecification,productOfferingPrice`);
          product.variants = (0, _AccessoryParser.parseAccessoryResponse)(variants);
          product.selectedVariant = product.variants.variants[0];
        }
      }
      const upsellSettings = yield (0, _effects.select)((0, _widgetSelectors.selectUpsellSettings)(action.instanceId));
      const parsedOfferings = (0, _upsellParser.default)(upsellOfferings, upsellSettings);
      yield (0, _effects.put)({
        ...(0, _productCatalogActions.setProductRelationshipOffering)(parsedOfferings),
        instanceId: action.instanceId
      });
      const relationshipOfferingCategories = [];
      upsellOfferings.forEach(offering => {
        if (!relationshipOfferingCategories.includes(offering.category[0].id)) {
          relationshipOfferingCategories.push(offering.category[0].id);
        }
      });
      yield (0, _effects.put)({
        ...(0, _upsellActions.setProductRelationshipCategories)(relationshipOfferingCategories),
        instanceId: action.instanceId
      });
    } catch (e) {
      console.log(e);
    }
  }
}
function* watchProductRelationshipOfferings() {
  yield (0, _effects.takeEvery)(_productCatalogActions.FETCH_PRODUCT_RELATIONSHIP_OFFERING, fetchUpSellProducts);
  yield (0, _effects.takeEvery)(_productCatalogActions.FETCH_BROADBAND_ADDRESSES, fetchBroadbandAddresses);
}